import { render, staticRenderFns } from "./BookingForm.vue?vue&type=template&id=36e4e904&scoped=true"
import script from "./BookingForm.vue?vue&type=script&lang=js"
export * from "./BookingForm.vue?vue&type=script&lang=js"
import style0 from "./BookingForm.vue?vue&type=style&index=0&id=36e4e904&prod&lang=scss&scoped=true"
import style1 from "./BookingForm.vue?vue&type=style&index=1&id=36e4e904&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e4e904",
  null
  
)

export default component.exports